<template>
  <div class="wrapper-inside general-settings active">
    <div class="form-section">
      <div class="row">
        <div class="col-12">
          <h4 >Custom Widgets</h4>
        </div>
      </div>
      <form @submit.prevent="addItem">
        <CustomWidgetInput :isFirstInput="true" :variables="variables" @submit="addItem"></CustomWidgetInput>

        <CustomWidgetInput
          :key="index"
          v-for="(item, index) of customWidgets"
          :variables="variables"
          :customWidget="item"
          @remove="removeItem(index)"
        ></CustomWidgetInput>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import CustomWidgetInput from '@/components/admin/bots/settings/tabs/inputs/CustomWidgetInput.vue'
import { Feature } from '@/components/admin/bots/settings/tabs/features/feature'
import CustomWidgetsManagementMixin
  from '@/components/admin/bots/settings/_mixins/settings/custom-widgets-management.mixin'
import permissionsService from '@/services/tenants/permissions.service'
import { Permissions } from '@common/enums/tenant/user-permissions.enum'

@Component({ components: { CustomWidgetInput } })
export default class CustomWidgets extends Mixins(CustomWidgetsManagementMixin) implements Feature {
  readonly botName = this.$router.history.current.params.botName

  public hasSufficientPermission = false;

  public async save() {
    await this.updateWidgets()
  }

  async beforeMount() {
    this.initWidgets(this.botName)
    await this.getWidgets()
    this.hasSufficientPermission = await permissionsService.hasPermission(
      this.botName,
      this.permissions.ManageDashboardWidgets
    );
    this.$emit('on-permission-change')
  }

  get permissions() {
    return Permissions
  }

  addItem (item) {
    this.customWidgets.unshift(item)
  }

  removeItem (index) {
    this.customWidgets.splice(index, 1)
  }
}
</script>
